
import { ArrayFilter, ComparisonOperator } from "@/hooks/useArrayFilters";
import { useUUID } from "@/hooks/useUUID";
import { computed, defineComponent, ref, toRefs } from "vue";

export type NewArrayFilter = Pick<
	ArrayFilter,
	"key" | "operator" | "compareTo"
> & { title?: string; enabled?: boolean };

export default defineComponent({
	props: {
		options: {
			type: Array as () => {
				value: string;
				title: string;
				comparisonOperators?: ComparisonOperator[];
			}[],
			required: true,
		},
		filters: {
			type: Array as () => (ArrayFilter & { title: string })[],
			required: true,
		},
	},
	setup(props, { emit }) {
		const { options, filters } = toRefs(props);

		const getComparisonOptionsForKey = (key: string) => {
			const item = options.value.find(option => option.value === key);
			if (item && item.comparisonOperators) {
				return item.comparisonOperators;
			}
			return Object.values(ComparisonOperator);
		};

		const initialFilter: NewArrayFilter = {
			key: options.value[0].value,
			operator: getComparisonOptionsForKey(options.value[0].value)[0],
			compareTo: "",
		};

		const newFilter = ref<NewArrayFilter>({ ...initialFilter });
		const comparisonOptions = computed(() =>
			getComparisonOptionsForKey(newFilter.value.key)
		);
		const onKeyChange = () => {
			const key = newFilter.value.key;
			const operators = getComparisonOptionsForKey(key);
			if (!operators.includes(newFilter.value.operator)) {
				newFilter.value.operator = getComparisonOptionsForKey(key)[0];
			}
		};
		const handleAddFilter = () => {
			const title = options.value.find(
				option => option.value === newFilter.value.key
			)?.title;
			if (title) {
				emit("new-filter", { ...newFilter.value, title });
				newFilter.value = { ...initialFilter };
			}
		};

		const totalFilters = computed(
			() => filters.value.filter(filter => filter.enabled).length
		);

		const componentUUID = useUUID();

		return {
			newFilter,
			comparisonOptions,
			onKeyChange,
			handleAddFilter,
			totalFilters,
			componentUUID,
		};
	},
});
